import React from "react";
import { Leaf, Rocket, Globe, Key } from "lucide-react";

const benefits = [
  { icon: <Leaf className="text-blue-1" />, title: "Avoir de l’impact", desc: "Aider des jeunes à révéler leur potentiel." },
  { icon: <Rocket className="text-blue-1" />, title: "Valoriser ses compétences", desc: "Enseigner renforce ses connaissances et soft skills." },
  { icon: <Globe className="text-blue-1" />, title: "Rejoindre une communauté", desc: "Mentors, fablabs et partenaires connectés." },
  { icon: <Key className="text-blue-1" />, title: "Accéder à des opportunités", desc: "Collaborations, certifications, visibilité." },
];

const WhyTutor = () => (
  <section className="w-full bg-white py-12 px-6">
    <div className="max-w-6xl mx-auto text-center">
      <h3 className="text-title font-bold text-dark-1 mb-10">Pourquoi devenir tuteur ?</h3>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {benefits.map((b, i) => (
          <div key={i} className="p-6 rounded-2xl bg-light-5 shadow hover:shadow-lg transition">
            <div className="mb-3">{b.icon}</div>
            <h4 className="font-semibold text-dark-1">{b.title}</h4>
            <p className="text-light-1 text-sm">{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyTutor;
